// @flow
import * as React from 'react';
import cn from 'classnames';
import './TextField.scss';

type CustomProps = {
  /**
   * Classname added to the <input /> element
   */
  className?: string,
  /**
   * True to mark the input as invalid
   */
  isInvalid?: boolean,
  /**
   * A reference to the inner <input /> element
   */
  htmlRef?: React.Ref<'input'>
};

type InputProps = {
  /**
   * From the props in
   * https://github.com/facebook/flow/blob/v0.79.1/lib/dom.js#L3050
   */
  value?: string,
  /**
   * From the props in
   * https://github.com/facebook/flow/blob/v0.79.1/lib/dom.js#L3050
   */
  defaultValue?: string
};

export type Props = CustomProps & InputProps;

/**
 * A wrapper on top of the <input /> element, for all form related elements
 * (input, select, etc) we define our own versions because our needs are
 * different than the ones provided by bootstrap:
 *
 * - if we use bootstrap input besides setting the right default values we would
 *   still need to apply overrides (our inputs only have border bottom)
 * - bootstrap form variables depend on other component variables like tooltip
 * - we don't need sizes e.g. lg, sm
 */
export default function TextField({
  className,
  isInvalid,
  htmlRef,
  ...rest
}: Props) {
  const ns = TextField.block;
  const computedClassName = cn(
    {
      [ns]: true,
      [`${ns}--is-invalid`]: isInvalid
    },
    className
  );
  return <input ref={htmlRef} className={computedClassName} {...rest} />;
}

TextField.block = 'text-field';

TextField.defaultProps = {
  isInvalid: false
};



// WEBPACK FOOTER //
// ./src/components/api/components/TextField/TextField.js